export function isNil(val) {
  return val === undefined || val === null;
}